import api from '../services/api';

export default async function putCurso(url,json) {

  return api
    .put(url, json,
    {
      headers: { 'Content-Type': 'application/json', },
    })
    .then(response => {
      return {type: 'success', data: response.data};
    })
    .catch(error => {
      return {type:'error', data: {code: error.response.data.code, detail: error.response.data.detail}}
    });
}
